import useSWR from 'swr';
import swrConfig from 'utils/swrConfig';
import { getLabelCount } from '../fetchers/get-label-count';

/** `enabled: false` skips the request (the SWR key becomes null). */
export const useLabelCountSWR = (from: string, to: string, enabled = true) => {
    const { data, isLoading, error, mutate } = useSWR(
        enabled ? ['label-count', from, to] : null,
        () => getLabelCount(from, to),
        swrConfig
    );

    return { data, isLoading, error, mutate };
};
